import React from "react";
import { Box, Flex, Text, HStack } from "@chakra-ui/react";
import { FiTrendingUp } from "react-icons/fi";

/**
 * ReportsStats component displays E-Score and Average Impact Score
 * with trending indicator as shown in Figma design
 */
const ReportsStats = ({
  eScore = 0,
  averageImpactScore = 0,
  showTrending = true,
}) => {
  return (
    <Box>
      <Flex justify="space-between" align="flex-start" gap={6}>
        {/* Left side - Stats */}
        <Box flex={1}>
          <Flex direction="column" gap={2}>
            {/* E-Score Label and Value */}
            <Text
              fontSize="18px"
              fontWeight="700"
              lineHeight="1.33"
              color="#433358"
              fontFamily="Geist, sans-serif"
            >
              E-Score
            </Text>
            <Text
              fontSize="14px"
              fontWeight="84"
              lineHeight="1.43"
              letterSpacing="-0.02em"
              color="#433358"
              fontFamily="Geist, sans-serif"
            >
              Max Impact Score
            </Text>
          </Flex>
        </Box>

        {/* Right side - Score with trending */}
        <Box position="relative">
          <HStack spacing={1} align="center">
            {showTrending && (
              <Box
                bg="#DBFFDD"
                borderRadius="4px"
                p={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="24px"
                h="24px"
              >
                <FiTrendingUp size={12} color="#009008" />
              </Box>
            )}
            <Text
              fontSize="18px"
              fontWeight="700"
              lineHeight="1.33"
              color="#433358"
              fontFamily="Geist, sans-serif"
            >
              {Math.round(averageImpactScore)}%
            </Text>
          </HStack>
        </Box>
      </Flex>

      {/* Bottom border line */}
      <Box w="full" h="1px" bg="rgba(208, 204, 213, 0.3)" mt={4} />
    </Box>
  );
};

export default ReportsStats;
